module.exports = __webpack_public_path__ + "static/media/print.a5c83b40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/print.svg
// module id = 1357
// module chunks = 0